import React, { useEffect, useState } from 'react'
import { getMenuDetails, seriesData, seriesEpisodeData } from '../../services/channelData.service';
import Loading from './Loading';
import SeriesDetailPage from '../pages/SeriesDetailPage';
import { getLocalStorageData } from '../../utils/localCache.util';

const SeriesDetailPageWrapper = ({ activePage, menuData, activePageLayout, handlePageChange, landingPageButton }) => {
  const [seriesDetails, setSeriesDetails] = useState(null);
  const [videoData, setVideoData] = useState([]);
  const [activeSubPage, setActiveSubPage] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      const playlistCategoryTitle = window.location.pathname.split('/')[3];
      const seriesTitleSlug = window.location.pathname.split('/')[4];
      try {
        const seriesId = getLocalStorageData('seriesId') || '';
        const match = seriesId.match(/gridv(\d+)/);
        let gridvId = match ? match[1] : null;
        const menuData = await getMenuDetails(activePage);
        const matchingPlaylist = menuData?.content?.playlists?.find(
          (playlist) => String(playlist.title.toLowerCase().replace(/\s+/g, '_').replace(/[^\w-]/g, '')) === playlistCategoryTitle
        );

        const program_type = matchingPlaylist?.program_type ?? 'videos';
        if (gridvId === null) {
          const seriesDetails = await seriesData(activePage, matchingPlaylist._id);
          const matchedSeries = seriesDetails.content.series.find((series) => 
            series.title.toLowerCase().replace(/\s+/g, '_').toLowerCase() === seriesTitleSlug.toLowerCase()
          );
          const seriesId = matchedSeries.id;
          gridvId = seriesId;
        }

        const series_id = seriesId.match(/item(\d+)/);
        let seriesPlaylistId = series_id ? series_id[1] : matchingPlaylist._id;
        setActiveSubPage(seriesPlaylistId);

        const seriesDatas = await seriesEpisodeData(activePage, seriesPlaylistId, gridvId);
        const seriesDetails = seriesDatas.content.series
        const formattedSeries = seriesDetails.map((s) => ({
          id: s._id,
          title: s.title,
          long_description: s.long_description || '',
          short_description: s.short_description || '',
          posterH: s.poster_16_9,
          posterV: s.poster_9_16,
          release_date: s.release_date,
          episodes: s.episodes,
          type: program_type,
        }));
        setSeriesDetails(formattedSeries[0]);
        setVideoData(formattedSeries[0]?.episode);
      } catch (error) {
        console.error('Error fetching detail data:', error);
      }
    };

    fetchData();
  }, [activePage]);

  if (!seriesDetails) {
    return <Loading showVideo={false} />;
  }

  return (
    <SeriesDetailPage
      key={seriesDetails.id || seriesDetails._id}
      detailPageData={seriesDetails}
      videos={videoData}
      containerIdPrefix={`item${seriesDetails.id || seriesDetails._id}`}
      activePage={activePage}
      activeSubPage={activeSubPage}
      handleHideDetailPage={() => { }}
      setShowDetailPage={() => { }}
      menuData={menuData}
      activePageLayout={activePageLayout}
      handlePageChange={handlePageChange}
      landingPageButton={menuData[0].id}
    />
  );
};

export default SeriesDetailPageWrapper
